import { forEach as _forEach } from 'lodash'
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, ControlLabel, FormControl, FormGroup, HelpBlock, Row } from 'react-bootstrap';

import { getSalutationOptions } from 'helpers/clients';
import { useSelector } from 'react-redux';
import { intlModule } from '@chedri/base';
import ContactListModal from '../../modals/ContactListModal';
import IconButton from '../../IconButton';
import ContactModal from '../../modals/ContactModal';

// CartWizardContactForm.propTypes = {
//   name: PropTypes.string.isRequired,
//   // eslint-disable-next-line react/forbid-prop-types
//   contact: PropTypes.object,
//   addable: PropTypes.bool,
//   onChange: PropTypes.func,
// };

// CartWizardContactForm.defaultProps = {
//   contact: undefined,
//   addable: false,
//   onChange: () => undefined,
// };

function FieldGroup({ id, label, help, value, ...props }) {
  return (
    <FormGroup controlId={id}>
      <ControlLabel style={{ whiteSpace: 'nowrap' }}>{label || <span>&nbsp;</span>}</ControlLabel>
      <FormControl {...props} value={value || ''} readOnly />
      {help && <HelpBlock>{help}</HelpBlock>}
    </FormGroup>
  );
}

function SelectGroup({ id, label, help, options, value, ...props }) {
  return (
    <FormGroup controlId="formControlsSelect">
      <ControlLabel>{label || <span>&nbsp;</span>}</ControlLabel>
      <FormControl componentClass="select" onChange={() => {}} {...props}>
        {options.map(({ value, label }) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </FormControl>
      {help && <HelpBlock>{help}</HelpBlock>}
    </FormGroup>
  );
}

function CartWizardContactForm({ contact, address, target }) {
  const messages = useSelector(intlModule.selectors.getMessages);

  let landline = null;
  let mobile = null;

  // eslint-disable-next-line no-unused-expressions
  contact?.numbers?.forEach(item => {
    const { type, number } = item;
    if (type === 'phone') {
      landline ??= number;
    } else if (type === 'mobile') {
      mobile ??= number;
    }
  });

  if (contact?.target && target?.profile && contact.target.trim() === target.username.trim()) {
    if (target.profile.phone) {
      landline ??= target.profile.phone;
    }
    if (target.profile.mobile) {
      mobile ??= target.profile.mobile;
    }
  }

  return (
    <div>
      <Row>
        <Col xs={12} md={12} className="wizard-contact-form__left">
          <FieldGroup id="companyInput" type="text" label={messages.company} value={contact.company} />
          <Row>
            <Col xs={6}>
              <SelectGroup
                id="salutationInput"
                label={messages.salutation}
                options={getSalutationOptions(messages)}
                defaultValue={contact.salutation}
                disabled
              />
            </Col>
            <Col xs={6}>
              <FieldGroup id="titleInput" type="text" label={messages.title} value={contact.title} />
            </Col>
          </Row>
          <FieldGroup id="nameInput" type="text" label={messages.last_name} value={contact.last_name} />
          <FieldGroup id="firstnameInput" type="text" label={messages.first_name} value={contact.first_name} />
          <Row>
            <Col xs={6}>
              <FieldGroup
                id="streetInput"
                type="text"
                label={`${messages.street}/${messages.house_number}/${messages.apartment_number}`}
                value={address.street}
              />
            </Col>
            <Col xs={4}>
              <FieldGroup id="houseNumberInput" type="text" label="" value={address.house_number} />
            </Col>
            <Col xs={2}>
              <FieldGroup id="apartmentNumberInput" type="text" label="" value={address.apartment_number} />
            </Col>
          </Row>
        </Col>
        <Col xs={12} md={12} className="wizard-contact-form__right">
          <Row>
            <Col xs={6} md={6}>
              <FieldGroup id="zipcodeInput" type="text" label={messages.zip_code} value={address.zipcode} />
            </Col>
            <Col xs={6} md={6}>
              <FieldGroup id="cityInput" type="text" label={messages.city} value={address.city} />
            </Col>
          </Row>
          <FieldGroup id="mobileInput" type="text" label={messages.mobile} value={mobile} />
          <FieldGroup id="phoneInput" type="text" label={messages.phone} value={landline} />
          <FieldGroup id="emailInput" type="text" label={messages.email} value={contact.email} />
          <FieldGroup id="countryInput" type="text" label={messages.country} value={address.country_name} />
        </Col>
      </Row>
    </div>
  );
}

export default CartWizardContactForm;
